var render = function render(){var _vm=this,_c=_vm._self._c;return _c('coop-tab-rate',{attrs:{"id":_vm.partnerId,"hotelOrPartner":"partner","sys":true,"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }